







/* tslint:disable */
import {
    Component,
    Vue,
    Prop,
    Watch
} from 'vue-property-decorator'
import Highcharts, {
    Chart, charts,
} from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import { getModule } from 'vuex-module-decorators'
import LocomotivesModule from '@/store/modules/LocomotivesModule'
import ParameterForGraph from '@/models/Graph/ParameterForGraph'
import Uuid from '@/services/Uuid'

exportingInit(Highcharts)
@Component
export default class Graph extends Vue {

    @Prop({
        type: Array,
        required: true
    })
    public data!: Array<ParameterForGraph>

    @Prop({
        type: String,
        required: true
    })
    public parameterName!: string
    
    private locomotivesModule = getModule(LocomotivesModule, this.$store)

    private graphData = new Array<ParameterForGraph>()

    private allData = []
    
    private updateCount = 0

    private chartOptions = {
        title: {
            text: this.parameterName
        },
        series: [{
            name: this.parameterName,
            data: []//this.values
        }],
        xAxis: {
            type: 'datetime'
        },
        height: 150,
        width: 350,
        scrollbar: {
            enabled: true
        },
        id: new Uuid().uuidv4()
    }

    get values(): any {
        const formatedData = this.data.map((d: any) => [new Date(d.date), Number(d.value)])
        return formatedData
    }

    mounted() {
        const chart = Highcharts.charts.find((c) => (c?.options as any).id == this.chartOptions.id)!
        const data = this.data.filter((llp) => llp.name == this.parameterName).map((d: any) => [new Date(d.date).getTime(), Number(d.value)])
        this.allData = this.allData.concat(data as any)
        chart.series[0].setData(this.allData, true)
        this.updateCount++
    }

    @Watch('locomotivesModule.lastLocomotiveParameters')
    private dataUpdated() {
        const chart = Highcharts.charts.find((c) => (c?.options as any).id == this.chartOptions.id)!
        const data = this.locomotivesModule.lastLocomotiveParameters.filter((llp) => llp.name == this.parameterName).map((d: any) => [new Date(d.date).getTime(), Number(d.value)])
        this.allData = this.allData.concat(data as any)
        chart.series[0].setData(this.allData, true)
        this.updateCount++

        // chart.series[0].setData([...chart.series[0].data, ...data], true)
        /*
        const newData = data.filter((d: any) => {
            return !this.graphData.some((g) => new Date(g.date).getTime() == d[0].getTime() && Number(g.value) == d[1])
        })

        if (newData.length > 0) {
            chart.series[0].setData(newData, true)
        }
        */
        // this.graphData = [...this.data]
    }
    

    /**
     * Synchronize zooming through the setExtremes event handler.
     */
    /*
    syncExtremes(e: any) {
      debugger
      const thisChart = this.chart;

      if (e.trigger !== "syncExtremes") {
        // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function (chart: any) {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) {
              // It is null while updating
              chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                trigger: "syncExtremes"
              });
            }
          }
        });
      }
    }*/

    scroll(e: any) {
        for (let i = 0; i < Highcharts.charts.length; ++i) {
            const chart = Highcharts.charts[i] as Chart;
            const event = chart.pointer.normalize(e); // Find coordinates within the chart
            let point;
            for (let j = 0; j < chart.series.length && !point; ++j) {
                point = (chart.series[j] as any).searchPoint(event, true);
            }
            if (!point) return;

            if (e.type === "mousemove") {
                point.onMouseOver();
                chart.xAxis[0].drawCrosshair(event, point); // Show the crosshair
            } else {
                point.onMouseOut();
                chart.tooltip.hide(point);
                chart.xAxis[0].hideCrosshair();
            }

        }
    }
}
